import { Type } from '../types/Type';

export function resolveBranchCategoryIds(selectedTypes: Type[]): number[] {
    const ids = new Set<number>();

    for (const type of selectedTypes) {
        if (type.kKategorie != null && type.kKategorie > 0) {
            ids.add(type.kKategorie);
        }
    }

    return [...ids].sort((a, b) => a - b);
}

export function branchCategoryIdsKey(branchCategoryIds: number[]): string {
    return branchCategoryIds.join(',');
}
